import React, { useState } from "react";
import { Form, Button, Card, Alert, Container, Row, Col, InputGroup } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import loginGif from "../Assets/login-security.gif";
import "./Login.css";
import { FiUser, FiMail, FiPhone, FiLock, FiHome, FiMapPin, FiGlobe } from "react-icons/fi";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Register = () => {
    const navigate = useNavigate();
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [password, setPassword] = useState("");
    const [street, setStreet] = useState("");
    const [city, setCity] = useState("");
    const [state, setState] = useState("");
    const [zip, setZip] = useState("");
    const [country, setCountry] = useState("");
    const [error, setError] = useState(null);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);
        try {
            const address = { street, city, state, zip, country };
            await axios.post("https://madhusewingmachines.com/api/auth/register", {
                name, email, phone, password, address
            });
            toast.success("🎉 Registration successful! Please log in.", {
                position: "top-center",
                autoClose: false,
                closeOnClick: true,
                onClose: () => navigate("/login"),
            });
        } catch (err) {
            setError(err.response?.data?.message || "Registration failed. Try again.");
        }
    };

    return (
        <Container fluid className="login-page">
            <Row className="justify-content-center align-items-start g-0 login-row">
                <Col xs={12} md={6} className="d-flex justify-content-center align-items-center login-visual order-1">
                    <img src={loginGif} alt="Secure" className="login-gif" />
                </Col>
                <Col xs={12} md={6} className="p-4 p-md-5 order-2">
                    <Card className="shadow-sm border-0 login-card">
                        <Card.Body className="p-4 p-md-5">
                            <h1 className="login-title mb-2">Create account</h1>
                            <p className="login-subtitle mb-4">Join us and start your journey today.</p>
                            {error && <Alert variant="danger">{error}</Alert>}
                            <Form onSubmit={handleSubmit}>
                        <Form.Group className="mb-3">
                            <Form.Label>Name</Form.Label>
                            <InputGroup>
                                <InputGroup.Text><FiUser /></InputGroup.Text>
                                <Form.Control type="text" placeholder="Enter your name" value={name} onChange={(e) => setName(e.target.value)} required />
                            </InputGroup>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Email</Form.Label>
                            <InputGroup>
                                <InputGroup.Text><FiMail /></InputGroup.Text>
                                <Form.Control type="email" placeholder="Enter your email" value={email} onChange={(e) => setEmail(e.target.value)} required />
                            </InputGroup>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Phone</Form.Label>
                            <InputGroup>
                                <InputGroup.Text><FiPhone /></InputGroup.Text>
                                <Form.Control type="text" placeholder="Enter your phone number" value={phone} onChange={(e) => setPhone(e.target.value)} required />
                            </InputGroup>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Password</Form.Label>
                            <InputGroup>
                                <InputGroup.Text><FiLock /></InputGroup.Text>
                                <Form.Control type="password" placeholder="Create a password" value={password} onChange={(e) => setPassword(e.target.value)} required />
                            </InputGroup>
                        </Form.Group>

                        <hr />
                        <h5>Address Details</h5>

                        <Form.Group className="mb-3">
                            <Form.Label>Street Address</Form.Label>
                            <InputGroup>
                                <InputGroup.Text><FiHome /></InputGroup.Text>
                                <Form.Control type="text" placeholder="Street address" value={street} onChange={(e) => setStreet(e.target.value)} required />
                            </InputGroup>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>City</Form.Label>
                            <InputGroup>
                                <InputGroup.Text><FiMapPin /></InputGroup.Text>
                                <Form.Control type="text" placeholder="City" value={city} onChange={(e) => setCity(e.target.value)} required />
                            </InputGroup>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>State</Form.Label>
                            <InputGroup>
                                <InputGroup.Text><FiMapPin /></InputGroup.Text>
                                <Form.Control type="text" placeholder="State" value={state} onChange={(e) => setState(e.target.value)} required />
                            </InputGroup>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Zip Code</Form.Label>
                            <InputGroup>
                                <InputGroup.Text><FiMapPin /></InputGroup.Text>
                                <Form.Control type="text" placeholder="ZIP / Postal Code" value={zip} onChange={(e) => setZip(e.target.value)} required />
                            </InputGroup>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Country</Form.Label>
                            <InputGroup>
                                <InputGroup.Text><FiGlobe /></InputGroup.Text>
                                <Form.Control type="text" placeholder="Country" value={country} onChange={(e) => setCountry(e.target.value)} required />
                            </InputGroup>
                        </Form.Group>

                        <Button type="submit" className="w-100 login-btn">Sign up</Button>
                    </Form>
                    <div className="text-center mt-3">
                        Already have an account? <Link to="/login">Log in</Link>
                    </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            <ToastContainer />
        </Container>
    );
};

export default Register;
